module.exports = __webpack_public_path__ + "media/images/iso-14001-227c73bf501e913dc7b75879ba79edeb.jpg";